import { Flex, FlexProps } from '@mantine/core';
import { useHover } from '@mantine/hooks';
import { HiArrowRight } from 'react-icons/hi2';
import { Link as WouterLink } from 'wouter';

interface Props extends Omit<FlexProps, 'direction'> {
  to: string;
  direction?: 'left' | 'right';
}

export default function Link({
  children,
  direction = 'right',
  to,
  ...rest
}: Props) {
  const { hovered, ref } = useHover();

  return (
    <WouterLink to={to} style={{ textDecoration: 'none' }}>
      <Flex
        {...rest}
        ref={ref}
        align="center"
        gap="xs"
        c="var(--mantine-primary-color-filled)"
        style={{
          display: 'inline-flex',
          flexDirection: direction === 'left' ? 'row-reverse' : 'row',
          borderBottom: `1px solid ${
            hovered ? 'var(--mantine-primary-color-filled)' : 'transparent'
          }`,
        }}
      >
        <span style={{ fontWeight: 500 }}>{children}</span>
        <HiArrowRight
          style={{
            color: 'var(--mantine-primary-color-filled)',
            width: 16,
            height: 16,
            strokeWidth: 2.5,
            transform: direction === 'left' ? 'rotate(180deg)' : 'none',
          }}
        />
      </Flex>
    </WouterLink>
  );
}
